// ----------------------------------------------------------------------------
// Snippet: Reviews
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_product-reviews.scss';